import { render, staticRenderFns } from "./GamesManagement.vue?vue&type=template&id=1d9a97db&scoped=true&"
import script from "./GamesManagement.vue?vue&type=script&lang=ts&"
export * from "./GamesManagement.vue?vue&type=script&lang=ts&"
import style0 from "./GamesManagement.vue?vue&type=style&index=0&id=1d9a97db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a97db",
  null
  
)

export default component.exports